<template>
  <div class="footer" >
    <img :src="`/imgs/${bg_image_previous}`" :class="bg_previous_class" alt="">
    <img :src="`/imgs/${bg_image_current}`" :class="bg_current_class" alt="">
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    bg_image: {
      type: String,
      required: true
    },
    animate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bg_image_current: this.bg_image,
      bg_image_previous: "",
      bg_current_class: "",
      bg_previous_class: ""
    }
  },
  watch: {
    bg_image: function(newVal, oldVal) { 
      let vm = this;
      this.bg_image_current = newVal;
      this.bg_image_previous = oldVal;

      this.bg_previous_class = "bg-img-previous";
      this.bg_current_class = "bg-img-current";

      setTimeout(() => {
        vm.bg_previous_class = "bg-img-previous-after";
        vm.bg_current_class = "";
      }, 500)
    }
  }
}
</script>

<style lang="scss">
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    overflow: hidden;
    img {
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -960px;
      height: 200px;
      opacity: 0.4;

      &.bg-img-previous {
        animation: fadeOut .5s ease-out;
        opacity: 0;
      }
      &.bg-img-previous-after {
        opacity: 0;
      }
      &.bg-img-current  {
        animation: fadeIn .5s ease-out;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .footer {
      height: 160px;
      img {
        margin-left: -768px;
        height: 160px;
      }
    }
  }
  @media screen and (max-width: 330px) {
    .footer {
      height: 120px;
      img {
        margin-left: -576px;
        height: 120px;
      }
    }
  }
</style>